import { useTokenizedApi } from '../useTokenizedApi';
import { useQuery } from 'react-query';

/**
 * **`React hook`** The full name of the authenticated user. Display the user’s
 * name in an account menu, for example. The name is available as soon as the
 * login credentials are verified, so you can display it in the MFA prompt
 * before full authentication.
 *
 * @returns The user’s full name
 *
 * @category Logging in and Security
 */

export function useOwnFormattedName() {
  const tokenizedApi = useTokenizedApi();
  const user = useQuery(tokenizedApi.account.userDetailsQuery());
  return user?.data?.name;
}
